/**
 * Image selection gallery directive
 *
 * Usage:
 *
 *   controller.js:
 *     vm.handleSelection = function(selectedImage) { ... }
 *
 *   view.html:
 *     <button cm-image-gallery on-select="vm.handleSelection">Select image</button>
 */
//retrieve the module then create a directive.
// directive creates a new directive and an calls the factory function when it is matched for the first time
// $uibModal is a service for creating modal windows
angular.module('clientDashboardApp.reviewBuilder').directive('cmImageGallery', function($uibModal) {
  let openModal = function(parentScope) {
    let modalInstance = $uibModal.open({
      controller: modalGalleryCtrl,
      controllerAs: 'vm',
      template: require("./imageSelector.html"),
      windowClass: 'gallery-modal',
      scope: parentScope,
      resolve: {
        user: function(userService) { return userService.currentUser() }
      },
      size: 'lg'
    });

    modalInstance.result.then(parentScope.onSelect());
  };

  return {
    restrict: 'A',//Directive matches attribute  name only
    scope: {
      onSelect: '&',
      selectedImage: '=', //Bind all these to local scope. selectedImages is bound to selected-images in HTML
      maxDimensions: '=',
      minDimensions: '=',
      minFileSizeBytes: '=',
      maxFileSizeBytes: '=',
      imageAspectRatio: '=',
      aspectRatioPrettyReadable: '=',
    },
    link: function(scope, element) {
      element.on('click', () => openModal(scope)); //This opens it in modal form when element is clicked
    }
  }

});

modalGalleryCtrl.$inject = ['$scope', 'imageManagerService', '$uibModal', '$stateParams', 'confirmService', 'user'];
function modalGalleryCtrl($galleryScope, imageManagerService, $uibModal, $stateParams, confirmService, user) {

  if ($galleryScope.maxFileSizeBytes === undefined || parseInt($galleryScope.maxFileSizeBytes || 0) > 2000000) {
    $galleryScope.maxFileSizeBytes = "2000000" // 2MB max file size enforced on backend
  }

  this.query = '';
  let vm = this;

  vm.alert = {
    show: false
  }

  vm.statusInfo = {
    show:false
  }


  vm.uploadState = "initialized";

  this.isLoading = true;

  imageManagerService.listImages().then(images => {
    this.items = images;
    this.filterItems();
  }).finally(() => this.isLoading = false);

  this.canModifyImage = function(image) {
    return _.includes(user.permissions, 'UserManagement') || image.creatorId === user.userId;
  }


  this.pushUploadedImage = (image) => {
    this.items.push(image);
    this.filterItems();
  }

  this.select = image =>  $galleryScope.$close(image)

  this.filterItems = () => {
    if (this.query.length > 0) {
      this.filteredItems = this.items.filter(item => item.name.toLowerCase().includes(this.query))
    } else {
      this.filteredItems = this.items;
    }

    if ($galleryScope.selectedImage) {
      // remove the selected image
      this.filteredItems = this.filteredItems.filter(item => item._id != $galleryScope.selectedImage._id)
      this.filteredItems.unshift($galleryScope.selectedImage); // And push the selected image to the top
    }
  };

  $galleryScope.clearAllStatusMessages = function() {
    $galleryScope.clearErrors()
    $galleryScope.clearStatus()
    vm.closeAlert()
    vm.closeStatus()
  }

  $galleryScope.clearErrors = function () {
    $galleryScope.uploadErrors = new Array();
  }

  $galleryScope.clearStatus = function () {
    $galleryScope.statusMessages = new Array();
  }

  $galleryScope.addError = function(theErrorString){
    $galleryScope.uploadErrors.push(theErrorString);
    $galleryScope.showErrors();
  }

  $galleryScope.addStatus = function(theStatusMessage){
    $galleryScope.statusMessages.push(theStatusMessage);
    $galleryScope.showStatus();
  }

  $galleryScope.showErrors = function () {
    let displayMessage = $galleryScope.uploadErrors.join("<br>")
    vm.alert = {
      show: true,
      type: "danger",
      message: displayMessage
    }
    vm.uploadState = "error";

  }

  $galleryScope.showStatus = function () {
    let displayMessage = $galleryScope.statusMessages.join("<br>")
    vm.statusInfo = {
      show: true,
      type: "success",
      message: displayMessage
    }
  }

  $galleryScope.upload = function(files) {
    $galleryScope.clearAllStatusMessages()
    if (files.length == 0) {
      return;
    }
    vm.uploadState = "uploading";
    // $galleryScope.myField.files....

    function notAnImage(myFile) {
      let notImage = myFile.type.search(/image\/.*/) == -1;
      if(notImage){
        $galleryScope.addError(`<span class="fas fa-exclamation-triangle text-danger fa-status"></span>Error: Invalid file type.  Only images are allowed. ` + myFile.name)
      }
      return notImage
    }



    const doUpload = (theFile) => {
      imageManagerService.uploadImage(theFile, $galleryScope.minFileSizeBytes, $galleryScope.maxFileSizeBytes).then((imageResult) => {
        $this.onSuccess(imageResult);
      }, errorResult => {
        $this.onError(errorResult);
      });
    }

      function shouldCheckFileSize() {
        var answer = false
        if ($galleryScope.maxDimensions || $galleryScope.minDimensions) {
          answer = true
        }
        return answer;
      }

      function uploadIfRightSize(fileToBeChecked) {
        let badFileSize = false;
        if(shouldCheckFileSize()) {
          const reader = new FileReader;
          reader.onload = function () {
            const img = new Image;
            img.onload = function () {
              $galleryScope.$apply(() => {
                if ($galleryScope.maxDimensions && (img.naturalHeight > $galleryScope.maxDimensions.height || img.naturalWidth > $galleryScope.maxDimensions.width)) {
                  const errorMessage = `<span class="fas fa-exclamation-triangle text-danger fa-status"></span>Error: `+fileToBeChecked.name+` is too large.  Must be no larger than ${$galleryScope.maxDimensions.width} x ${$galleryScope.maxDimensions.height} `
                  $galleryScope.addError(errorMessage)
                } else if ($galleryScope.minDimensions && (img.naturalHeight < $galleryScope.minDimensions.height || img.naturalWidth < $galleryScope.minDimensions.width)) {
                  const errorMessage = `<span class="fas fa-exclamation-triangle text-danger fa-status"></span>Error: `+fileToBeChecked.name+` is too small.  Must be no smaller than ${$galleryScope.minDimensions.width} x ${$galleryScope.minDimensions.height}`
                  $galleryScope.addError(errorMessage)
                } else {
                  doUpload(fileToBeChecked)
                }
              })
            }
            img.src = reader.result;
          }
          reader.readAsDataURL(fileToBeChecked);
        } else {
          doUpload(fileToBeChecked)
        }

      }


    let notImages = files.filter(myFile => notAnImage(myFile)) //mark files that are not images
    const imageFiles = files.filter(myFile => !notImages.includes(myFile)) //Image files are the files that aren't in the bad set
    imageFiles.forEach(uploadIfRightSize)

    if(notImages.length>0) {
      notImages.forEach(f => $galleryScope.addError(f.errorMessage))
    }

  }

  vm.checkDimensions = function($event, item) {
    if ($galleryScope.maxDimensions && ($event.target.naturalHeight > $galleryScope.maxDimensions.height || $event.target.naturalWidth > $galleryScope.maxDimensions.width)) {
      item.disabled = true;
      item.tooltip = `Please select an image smaller than ${$galleryScope.maxDimensions.height} x ${$galleryScope.maxDimensions.width}`;
    } else if ($galleryScope.minDimensions && ($event.target.naturalHeight < $galleryScope.minDimensions.height || $event.target.naturalWidget < $galleryScope.minDimensions.width)) {
      item.disabled = true;
      item.tooltip = `Please select an image larger than ${$galleryScope.minDimensions.height} x ${$galleryScope.minDimensions.width}`;
    } else if ($galleryScope.minFileSizeBytes && item.fileSize && item.fileSize < parseInt($galleryScope.minFileSizeBytes)) {
      item.disabled = true;
      item.tooltip = `Please select an image with a file size smaller than ${$galleryScope.minFileSizeBytes}B.`
    } else if ($galleryScope.maxFileSizeBytes && item.fileSize && item.fileSize > parseInt($galleryScope.maxFileSizeBytes)) {
      item.disabled = true;
      item.tooltip = `Please select an image with a file size larger than ${$galleryScope.maxFileSizeBytes}B.`
    } else if ($galleryScope.imageAspectRatio && (Math.abs($galleryScope.imageAspectRatio - ($event.target.naturalWidth / $event.target.naturalHeight)) > .1)) {
      item.disabled = true;
      item.tooltip = `Please select an an aspect ratio equal to ${$galleryScope.aspectRatioPrettyReadable || $galleryScope.imageAspectRatio}. Current image has an aspect ratio of ${($event.target.naturalWidth / $event.target.naturalHeight).toFixed(2)}.`
    }
  }

  vm.closeAlert = function(){
    vm.alert = {
      show : false
    }
  }

  vm.closeStatus = function(){
    vm.statusInfo = {
      show : false
    }
  }


  this.onSuccess = (result) => {
    this.pushUploadedImage(result.data);
    vm.uploadState = "success";
    vm.activeTab = 0;
    $galleryScope.addStatus(`<span class="fas fa-check-circle text-success fa-status"></span>Image "${result.data.name}" successfully uploaded!`)
  }

  this.onError = (error) => {
    if(error.status==413 || error.status==412){
      vm.uploadState = "error";
      vm.alert = {
        show: true,
        message: `<span class="fas fa-exclamation-triangle text-danger fa-status"></span>${error.data}`,
        type: "danger"
      }
    }
  }

  vm.deleteImage = function (image) {
    confirmService.confirm('Confirm Deletion', `Are you sure you want to delete the image, "${image.name}"?`, confirmService.DELETE)
      .then(agreed => {
        if (agreed) {
          imageManagerService.deleteImage(image._id)
          vm.items = vm.items.filter(item => item._id != image._id)
          vm.filterItems()
        }
      })
  }
  var $this = this;
}
